import React, {Component} from 'react';
const { connect } = require('react-redux');

import HeaderBlackList from 'containers/member/blackList/HeaderBlackList';
import BlackListContent from 'containers/member/blackList/BlackListContent';
import Pagination from 'components/Pagination';
import Loading from 'components/Loading';
import Footer from '../../components/Footer';

import '../../sass/blackList.scss';

import {getMemberBlackList} from 'reducers/memberBlackList';

import {t} from 'l10n';
import queryString from "query-string";
import paths from 'paths';
import {BLACKLIST_PER_PAGE} from "../../constants/profiles";
import {diff} from "deep-object-diff";

class MemberBlackList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            search: this.constructor.getSearchObject(props)
        };
    }

    static getSearchObject({location}) {
        let query = queryString.parse(location.search);
        if(!query.order) query.order = "add_date";
        return query;
    }

    static fetchData({dispatch, location, params}) {
        let query = this.getSearchObject({location});

        let reducerParams = {
            limit: BLACKLIST_PER_PAGE,
            offset: ((query.page || 1) - 1) * BLACKLIST_PER_PAGE,
            order: query.order,
            desc: query.desc,
            ...params
        };

        return dispatch(getMemberBlackList(reducerParams));
    }

    componentDidMount() {
        let {dispatch, location, memberBlackList} = this.props;

        let newSearchObj = this.constructor.getSearchObject(this.props);

        if (!memberBlackList.list || Object.keys(diff(this.state.search, newSearchObj)).length) {
            this.constructor.fetchData({dispatch, location});
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            search: this.constructor.getSearchObject(nextProps)
        });
    }

    componentWillUpdate(nextProps, nextState) {
        let searchDiff = diff(this.state.search, nextState.search);

        if (Object.keys(searchDiff).length) {
            let {dispatch, location} = nextProps;

            this.constructor.fetchData({dispatch, location});
        }
    }

    render() {
        let {list, totalCount} = this.props.memberBlackList;

        let {page, order, desc} = this.state.search;
        desc = desc == 1 ? 1 : 0;

        if (!list) {
            return <Loading centered/>
        }

        return (
            <div id="wrapper" className="ui-kit-base">
                <HeaderBlackList title={t('My black list')}/>

                <aside className="blackList-members">
                    <div className="content">
                        
                        <h2 className="ui-header">{t('List of blocked users')} <span>{totalCount}</span></h2>
                        
                        <BlackListContent 
                            list={list} 
                            pathname={paths.memberBlackList.path} 
                            page={page} 
                            order={order} 
                            desc={desc ? 1 : 0}
                        />
                        
                        <Pagination
                            currentPage={page || 1}
                            itemsPerPage={BLACKLIST_PER_PAGE}
                            totalCount={totalCount}
                            urlFn={(page) => ({pathname: paths.memberBlackList.path, search: queryString.stringify({page: page, order: order, desc: desc ? 1:0})})}
                        />

                    </div>
                </aside>

                <Footer />
            </div>
        )
    }
}

export default connect(
    state => ({
        memberBlackList: state.memberBlackList
    }),
    null
)(MemberBlackList);


// WEBPACK FOOTER //
// ./src/containers/member/MemberBlackList.js